import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const pitchMediaTypeList = (params = '') => Http.get(`/admin/venture-pitch-media-types${serialize(params)}`)
export const pitchMediaTypeCreate = (params = '') => Http.post('/admin/venture-pitch-media-types', params)
export const pitchMediaTypeByID = (params = '') => Http.get(`/admin/venture-pitch-media-types/${params}`)
export const pitchMediaTypeUpdate = (params = '') => Http.put(`/admin/venture-pitch-media-types/${params.id}`, params)
export const pitchMediaTypeDestroy = (params = '') => Http.delete(`/admin/venture-pitch-media-types/${params.id}`)
